import { AuthManager } from 'spark-core-dx/managers';

export const getAuthenticationConvokeClientId = () => {
  const configuredClientId = String(
    AuthManager?.getConfiguredClientId?.() ?? '',
  ).trim();

  if (configuredClientId) return configuredClientId;

  return String(
    window.sessionStorage.getItem('resolved-client-id') ?? '',
  ).trim();
};

export const getAuthSessionRequestHeaders = (additionalHeaders = {}) => {
  const clientId = getAuthenticationConvokeClientId();

  return {
    ...additionalHeaders,
    ...(clientId ? {
      'C-DX-Auth-Client-Id': clientId,
      'C-DX-Client-Id': clientId,
    } : {}),
  };
};
